import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import * as fromUser from 'app/state/user';
import * as fromKeg from 'app/state/keg';
import * as fromSubscription from 'app/state/subscription';
import { IKeg } from 'app/models/keg';
import { KegService } from '../../../services/dal/keg.service';


@Component({
  selector: 'app-new-keg',
  templateUrl: './new-keg.page.html',
  styleUrls: ['./new-keg.page.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, IonicModule]
})
export class NewKegPage {

  @Input() isModal!: boolean;
  form: FormGroup;
  formSubmitted: boolean = false;

  newId: string;
  barId = this.store.selectSignal(fromUser.selectBarId);
  isPremium = this.store.selectSignal(fromSubscription.getHasPremium);


  constructor(
    private modalController: ModalController,
    private formBuilder: FormBuilder,
    kegService: KegService,
    private store: Store,
  ) {

    this.newId = kegService.getNewId();
    this.form = this.formBuilder.group({
      name: ['', Validators.required]
    });
  }


  save() {
    this.formSubmitted = true;

    if (!this.form.valid) {
      return;
    }

    const name = this.form.value.name;

    let keg: IKeg = {
      id: this.newId,
      order: 0,
      barId: this.barId(),
      beverageId: null,
      locationId: null,
      name: name,
      size: 0,
      amount: 0,
      nettoWeight: 4,
      bestBeforeDate: null,
      cleanDate: null,
      conditionDate: null,
      notificationMessage: null,
      notificationDate: null,
      tapDate: null
    };


    this.store.dispatch(fromKeg.addItem({ id: this.newId, item: keg }));
    if (this.isModal) {
      keg = {
        id: this.newId,
        ...keg,
      }
      this.modalController.dismiss({
        keg
      });
    } else {
      this.store.dispatch(fromKeg.setItemAndNavigate({ id: this.newId }));
    }

  }


  closeModal() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }

}
